import gql from 'graphql-tag';

const NAME = 'compositions_TechAdmin_Dealers_manageableDealers';

export default gql`
  query ${NAME} {
    manageableDealers {
      dealers {
        id
        name
        displayAddress {
          city
          province
        }
        shipTo
        billTo
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/Dealers/manageableDealersQuery.js